import { UseCase } from '@core/referential/use-case.enum'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import PendingComponent from '@/components/pending-component'
import { defaultAvailableUnits, useAuth } from '@/hooks/use-auth'
import { isUseCase } from '@/lib/utils'

export const SearchSchema = z.object({
  sites: z.array(z.string()).optional(),
  buildings: z.array(z.string()).optional(),
  rangeType: z.union([z.literal('last12Months'), z.literal('year'), z.literal('custom')]).default('last12Months'),
  year: z.number().optional(),
  compareYear: z.number().optional(),
  energies: z.array(z.string()).optional(),
  meterUsages: z.array(z.string()).optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  compareStartDate: z.string().optional(),
  compareEndDate: z.string().optional(),
})

export type Search = z.infer<typeof SearchSchema>

export function useSearch() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  const setSearch = (search: Search) => {
    void navigate({
      search,
      replace: true,
    })
  }

  return { search, setSearch }
}

export const Route = createFileRoute('/_dashboard/energy-usage/dashboard/')({
  validateSearch: SearchSchema,
  async beforeLoad() {
    if (!isUseCase(UseCase.CONSUMPTIONS)) {
      throw redirect({
        to: '/403',
        search: { reason: 'wrongUseCase' },
      })
    }

    const { setCurrentUnitType, setAvailableUnits, user } = useAuth.getState()

    setAvailableUnits(defaultAvailableUnits)

    if (user?.currentUsageType && !defaultAvailableUnits[user.currentUsageType].includes(user.currentUnitType)) {
      setCurrentUnitType(defaultAvailableUnits[user.currentUsageType][0])
    }
  },
  pendingComponent: PendingComponent,
})
